import { Entity, Field } from '@adornis/baseql/decorators.js';
import { BaseButton } from '@adornis/buildify/db/extensions/BaseButton.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { CampusLink } from './CampusLink.js';

@Entity()
export class CampusBaseButton extends BaseButton {
  static override _class = 'CampusBaseButton';

  @validate(nonOptional())
  @Field(() => CampusLink, { default: v => v ?? new CampusLink({}) })
  link!: CampusLink;
}
